module.exports = __webpack_public_path__ + "img/app0140.dad46092.png";